/** Shared easing & duration for framer-motion transitions */
export const EASE_SMOOTH = [0.22, 1, 0.36, 1] as const;
export const EASE_OUT_EXPO = [0.16, 1, 0.3, 1] as const;

export const DURATION_FAST = 0.35;
export const DURATION_NORMAL = 0.65;
export const DURATION_SLOW = 0.85;
export const DURATION_CROSSFADE = 0.9;

export const STAGGER_CHILDREN = 0.06;
export const STAGGER_DELAY = 0.08;

export const REVEAL_OFFSET_Y = 18;

export function crossfadeTransition(reduced: boolean | null) {
  return {
    duration: reduced ? 0.15 : DURATION_CROSSFADE,
    ease: EASE_SMOOTH,
  };
}

export function revealTransition(reduced: boolean | null) {
  return {
    duration: reduced ? 0.2 : DURATION_NORMAL,
    ease: EASE_SMOOTH,
  };
}
